import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { toast } from 'react-toastify';
import TestApiService from "../Services/TestApiService";

export default function Home() {
    const { instance } = useMsal();
    const service = React.useMemo(() => new TestApiService(instance), [instance]);
    const [whoAmI, setwhoAmI] = React.useState<string>();

    const isAuthenticated = useIsAuthenticated();

    const init = React.useCallback(async () => {
        try {
            //if (isAuthenticated) {
            let whoAmI = await service.whoAmI();
            setwhoAmI(whoAmI);
            // }
        }
        catch (error) {
            toast.error("Fout bij ophalen.");
        }
    }, [service]);


    React.useEffect(() => {
        init();
    }, [init]);

    return (
        <>
            <AuthenticatedTemplate>
                Hier een korte uitleg
                <br />
                {whoAmI}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                Hier wat marketing
            </UnauthenticatedTemplate>
        </>
    );
}